function itemFilter(searchValue, path) {
    return path.some((item) => String(item.label)
        .toLowerCase()
        .indexOf(String(searchValue).toLowerCase()) > -1);
}
function getPath(itemCache, pos) {
    const items = [];
    const nums = pos.split('-');
    if (nums === 2) {
        items.push(itemCache[pos]);
    }
    else {
        for (let i = 1; i < nums.length; i++) {
            const p = nums.slice(0, i + 1).join('-');
            items.push(itemCache[p]);
        }
    }
    return items;
}
export function cascaderFilter(itemCache, searchText, filterLocal) {
    if (!searchText)
        return [];
    const items = Object.keys(itemCache)
        .map((p) => itemCache[p])
        .filter((item) => !item.children || !item.children.length);
    const result = items
        .map((item) => getPath(itemCache, item.pos))
        .filter((path) => (filterLocal ? itemFilter(searchText, path) : true));
    return result;
}
